import { GlobalOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import React from 'react';

import { SPACING } from '../theme/tokens';

export default function ExternalLink({
  to,
  label,
  ariaLabel,
  onClick,
}: {
  to: string;
  label?: string | React.ReactElement;
  ariaLabel: string;
  onClick?: () => void;
}): React.ReactElement {
  let renderedLabel: React.ReactElement = <GlobalOutlined />;

  if (label) {
    renderedLabel = (
      <Space size={SPACING.xs} align="start">
        {label}
        <GlobalOutlined />
      </Space>
    );
  }

  return (
    <a
      href={to}
      target="_blank"
      rel="noreferrer noopener nofollow"
      aria-label={ariaLabel}
      onClick={(): void => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {renderedLabel}
    </a>
  );
}
